import { createSlice } from "@reduxjs/toolkit";

export const bussinesstypeSlice = createSlice({
  name: "bussinesstype",
  initialState: {
    value: "",
    list: [],
  },
  reducers: {
    clear: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = "";
    },
    set: (state, action) => {
      state.value = action.payload;
    },
    initialList: (state, action) => {
      state.list = action.payload;
    },
  },
});

export const { clear, set, initialList } = bussinesstypeSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectBussinesstype = (state) => state.bussinesstype.value;
export const getListofBussinesstype = (state) => state.bussinesstype.list;
export default bussinesstypeSlice.reducer;
